module.exports = __webpack_public_path__ + "img/desktop-error-500.46e5b9e4.svg";